import _ from 'lodash'
import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

import { isUser } from 'common/utils'
import { getSchoolUserStatisticsService } from 'page-modules/dashboard/school-details/service'

import AssignmentNudgeSet from './assignment-set'
import NudgeSet from './nudge-set'
import { loadAllNudgeSets, loadMyNudgeSets } from './service/actions'

@connect(
  (state) => ({
    user: state.root.user,
    mySets: state.nudges.mySets.items,
    allSets: state.nudges.allSets.items,
    nudgeSchoolStats: state.nudges.nudgeSchoolStats.items,
  }),
  (dispatch) => ({
    loadMyNudgeSets: () => dispatch(loadMyNudgeSets()),
    loadAllNudgeSets: () => dispatch(loadAllNudgeSets()),
    schoolUserStatsRequest: () => dispatch(getSchoolUserStatisticsService.actions.request()),
  }),
)
export default class Nudges extends React.Component {
  static propTypes = {
    user: PropTypes.object,
    loadAllNudgeSets: PropTypes.func,
    loadMyNudgeSets: PropTypes.func,
    schoolUserStatsRequest: PropTypes.func,
    allSets: PropTypes.array,
    nudgeSchoolStats: PropTypes.array,
    mySets: PropTypes.array,
  }

  componentDidMount() {
    if (this.canSeeAssignments) {
      this.props.loadAllNudgeSets()
      this.props.schoolUserStatsRequest()
    } else {
      this.props.loadMyNudgeSets()
    }
  }

  get canSeeAssignments() {
    return isUser.schoolImplementationTeam(this.props.user)
  }

  renderNudgeSets() {
    if (this.canSeeAssignments) {
      return _.map(this.props.allSets, (nudgeSet, index) => (
        <AssignmentNudgeSet
          key={nudgeSet.id}
          index={index}
          nudgeSet={nudgeSet}
          nudgeType={nudgeSet.nudge_set_type}
          stats={_.find(this.props.nudgeSchoolStats, { id: nudgeSet.id })}
        />
      ))
    }

    return _.map(this.props.mySets, (nudgeSet, index) => (
      <NudgeSet
        index={index}
        key={nudgeSet.id}
        nudgeSet={nudgeSet}
        nudgeType={nudgeSet.nudge_set_type}
      />
    ))
  }

  render() {
    return (
      <ul className="accordion nudges-list" role="tablist">
        {this.renderNudgeSets()}
      </ul>
    )
  }
}
